import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export default function CreatePlayer() {
  const { request } = useAuth();
  const [players, setPlayers] = useState([]);
  const [form, setForm] = useState({ player_name: '', profile_picture: '' });
  const [id, setId] = useState(null);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { request('get', '/account/admin/players').then(setPlayers).catch(err => setError(err.message)); }, [request]);
  async function save(event) {
    event.preventDefault(); setBusy(true); setError(''); setMessage('');
    try {
      await request(id ? 'put' : 'post', id ? `/account/admin/players/${id}` : '/account/admin/players', form);
      setForm({ player_name: '', profile_picture: '' }); setId(null); setMessage('Player saved.');
      setPlayers(await request('get', '/account/admin/players'));
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }
  return <main className="account-page"><h1>Manage player profiles</h1><p><Link to="/admin">Manage accounts</Link></p>
    {error && <p role="alert">{error}</p>}{message && <p role="status">{message}</p>}
    <h2>{id ? 'Edit player' : 'Create player'}</h2>
    <form className="account-form" onSubmit={save}>
      <label>Player name<input required maxLength={64} value={form.player_name} onChange={e => setForm({ ...form, player_name: e.target.value })} /></label>
      <label>Profile picture URL<input type="url" maxLength={2048} value={form.profile_picture} onChange={e => setForm({ ...form, profile_picture: e.target.value })} /></label>
      <div className="account-actions"><button disabled={busy}>Save player</button>{id && <button type="button" disabled={busy} onClick={() => { setId(null); setForm({ player_name: '', profile_picture: '' }); }}>Cancel</button>}</div>
    </form>
    <section><div className="account-table-wrap"><table className="account-table"><thead><tr><th>Player</th><th>Action</th></tr></thead><tbody>
      {players.map(p => <tr key={p.id}><td><Link to={`/players/${p.id}`}>{p.player_name}</Link></td><td><button disabled={busy} onClick={() => { setId(p.id); setForm({ player_name: p.player_name, profile_picture: p.profile_picture || '' }); }}>Edit</button></td></tr>)}
    </tbody></table></div></section>
  </main>;
}
